import {
  FETCH_ABOUT_REQUEST,
  FETCH_ABOUT_SUCCESS,
  FETCH_ABOUT_FAILURE,
} from "../action/contentAction";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const aboutReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ABOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ABOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_ABOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default aboutReducer;
